module.exports = vendor_121bc9f;